<template>
	<ext-dialog
		v-model="dialogVisibility"
		:title="$t('warehouse')"
		:primaryButtonText="$t('save')"
		@primaryButtonAction="saveAction"
		@closed="cancelAction"
	>
		<template #body>
			<div v-if="currentItem">
				<v-form ref="form" v-model="valid">
					<v-text-field v-model="currentItem.name" :label="$t('name')" :rules="rules.name" />
					<v-text-field v-model="currentItem.address" :label="$t('address')" :rules="rules.address" />
					<!-- <v-row class="mx-1 my-0 pa-0">
						<v-col cols="6" class="pa-0 pr-2">
							<v-text-field v-model="currentItem.latitude" :label="$t('latitude')" :rules="rules.latitude" />
						</v-col>
						<v-col cols="6" class="pa-0 pl-2">
							<v-text-field v-model="currentItem.longitude" :label="$t('longitude')" :rules="rules.longitude" />
						</v-col>
					</v-row> -->
					<v-text-field v-model="currentItem.email" :label="$t('email')" :rules="rules.email" />
					<v-text-field v-model="currentItem.phoneNumber" :label="$t('phone_number')" :rules="rules.phoneNumber" />
					<v-text-field v-model="currentItem.mobileNumber" :label="$t('mobile_number')" :rules="rules.mobileNumber" />
				</v-form>
			</div>
		</template>
	</ext-dialog>
</template>

<script>
import uiMixin from "../../../../store/interfaces/ui.mixin";
import remote from "../../../../data/remote";
import { mapGetters } from "vuex";
import ExtDialog from "../../../partials/dialogs/ExtDialog.vue";

export default {
	mixins: [uiMixin],
	props: ["value", "item"],
	components: { ExtDialog },
	data() {
		return {
			currentItem: null,
			valid: null,
			saving: false,
			rules: {
				name: [
					(v) => {
						if (!v) return this.$t("$validation.required", { item: this.$t("name") });
						if (v.length < 3) return this.$t("$validation.min_length", { item: this.$t("name"), length: "3" });
						if (v.length > 100) return this.$t("$validation.max_length", { item: this.$t("name"), length: "50" });
						return true;
					},
				],
				address: [
					(v) => {
						if (!v) return this.$t("$validation.required", { item: this.$t("address") });
						if (v.length > 100) return this.$t("$validation.max_length", { item: this.$t("address"), length: "100" });
						return true;
					},
				],
				// latitude: [
				// 	(v) => {
				// 		if (!v) return this.$t("$validation.required", { item: this.$t("latitude") });
				// 		if (isNaN(v)) return this.$t("$validation.invalid", { item: this.$t("latitude") });
				// 		return true;
				// 	},
				// ],
				// longitude: [
				// 	(v) => {
				// 		if (!v) return this.$t("$validation.required", { item: this.$t("longitude") });
				// 		if (isNaN(v)) return this.$t("$validation.invalid", { item: this.$t("longitude") });
				// 		return true;
				// 	},
				// ],
				phoneNumber: [
					(v) => {
						if (v && isNaN(v)) return this.$t("$validation.invalid", { item: this.$t("phone_number") });
						if (v && v.length > 20)
							return this.$t("$validation.max_length", { item: this.$t("phone_number"), length: "20" });
						return true;
					},
				],
				mobileNumber: [
					(v) => {
						if (v && isNaN(v)) return this.$t("$validation.invalid", { item: this.$t("mobile_number") });
						if (v && v.length > 20)
							return this.$t("$validation.max_length", { item: this.$t("mobile_number"), length: "20" });
						return true;
					},
				],
				email: [
					(v) => {
						if (!v) return true;
						if (!/.+@.+\..+/.test(v)) return this.$t("$validation.invalid", { item: this.$t("email") });
						return true;
					},
				],
			},
		};
	},
	computed: {
		...mapGetters(["company"]),
		dialogVisibility: {
			get() {
				return this.value;
			},
			set(val) {
				this.$emit("input", val);
			},
		},
	},
	watch: {
		value(val) {
			if (val) {
				this.handleProps();
			} else {
				this.reset();
			}
		},
		item: {
			immediate: true,
			handler() {
				if (this.value) this.handleProps();
			},
		},
	},
	methods: {
		handleProps() {
			if (this.item) {
				this.currentItem = Object.assign({}, this.item);
			} else {
				this.currentItem = {
					name: "",
					address: "",
					// latitude: 0,
					// longitude: 0,
					phoneNumber: "",
					mobileNumber: "",
					email: "",
				};
			}
		},
		reset() {
			if (this.$refs.form) this.$refs.form.reset();
			this.currentItem = null;
		},
		saveAction() {
			if (this.valid) {
				this.saving = true;
				const warehouse = {
					id: this.currentItem.id,
					name: this.currentItem.name,
					address: this.currentItem.address,
					// latitude: this.currentItem.latitude,
					// longitude: this.currentItem.longitude,
					phoneNumber: this.currentItem.phoneNumber,
					mobileNumber: this.currentItem.mobileNumber,
					email: this.currentItem.email,
				};
				const onSuccess = (result) => {
					this.saving = false;
					this.$emit("saved", result);
					this.showSnackBar({
						message: this.$t(this.currentItem.id ? "$message.updated" : "$message.created", {
							item: this.$t("warehouse"),
						}),
					});
				};
				const onFail = () => (this.saving = false);
				if (this.currentItem.id) {
					remote.warehouses.update(this.company.id, warehouse, { onSuccess, onFail });
				} else {
					remote.warehouses.create(this.company.id, warehouse, { onSuccess, onFail });
				}
			} else {
				this.$refs.form.validate();
			}
		},
		cancelAction() {
			this.$emit("input", false);
			this.$emit("closed");
		},
	},
};
</script>
